import { render, staticRenderFns } from "./PlanCreatedPopup.vue?vue&type=template&id=005b6ec8&scoped=true"
import script from "./PlanCreatedPopup.vue?vue&type=script&lang=js"
export * from "./PlanCreatedPopup.vue?vue&type=script&lang=js"
import style0 from "./PlanCreatedPopup.vue?vue&type=style&index=0&id=005b6ec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005b6ec8",
  null
  
)

export default component.exports